import { render, staticRenderFns } from "./SafetyStaffCreate.vue?vue&type=template&id=111c3fda&scoped=true"
import script from "./SafetyStaffCreate.vue?vue&type=script&lang=js"
export * from "./SafetyStaffCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111c3fda",
  null
  
)

export default component.exports